const delimiter = () => {
    return `<hr>`;
};

module.exports = delimiter;
